module.exports = __webpack_public_path__ + "static/assets/5b36d8cf15d803226e2fe4c0737be43f.svg";